export default __webpack_public_path__ + "static/media/family-DE.35e967f0.png";